// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2kCLm","list":"PatternAutocomplete_list__1K7yl"};